export default __webpack_public_path__ + "static/minorLeagues_thumbnail-6aba313c330c7f75ea80289440e39ed1.png";